import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import ClientBrief from "@/components/ClientBrief";

import Navigation from "@/components/numbardar/Navigation";
import Hero from "@/components/numbardar/Hero";
import SummaryHero from "@/components/numbardar/SummaryHero";
import StatsBar from "@/components/numbardar/StatsBar";
import PillarCardStrip from "@/components/numbardar/PillarCardStrip";
import About from "@/components/numbardar/About";
import Dealroom from "@/components/numbardar/Dealroom";
import Estates from "@/components/numbardar/Estates";
import ComingSoon from "@/components/numbardar/ComingSoon";
import Geography from "@/components/numbardar/Geography";
import AdvisoryCTA from "@/components/numbardar/AdvisoryCTA";
import BuilderTrust from "@/components/numbardar/BuilderTrust";
import ListSellBuy from "@/components/numbardar/ListSellBuy";
import IntelligenceFeed from "@/components/capital/IntelligenceFeed";
import Testimonials from "@/components/numbardar/Testimonials";
import Contact from "@/components/numbardar/Contact";
import ContactModal from "@/components/numbardar/ContactModal";
import Footer from "@/components/numbardar/Footer";
import CustomCursor from "@/components/numbardar/CustomCursor";
import WhatsAppButton from "@/components/numbardar/WhatsAppButton";
import PageLoader from "@/components/numbardar/PageLoader";

import { ViewRouterProvider, useViewRouter } from "@/hooks/useViewRouter";

/**
 * Renders the five SPA views. Only the active view is visible.
 * Homepage scroll order:
 *   ① Hero  ② Pillar strip  ③ Stats Bar  ④ Who We Are  ⑤ Four Pillars
 *   ⑥ Wealth CTA  ⑦ Markets  ⑧ Builder Trust  ⑨ Stories  ⑩ Contact  ⑪ Footer
 */
const ViewSwitch = () => {
  const { view } = useViewRouter();
  const isActive = (id) => view === id;

  const baseViewStyle = (active) => ({
    display: active ? "block" : "none",
    opacity: active ? 1 : 0,
  });
  const innerViewStyle = (active) => ({
    ...baseViewStyle(active),
    paddingTop: 88,
  });

  return (
    <main>
      {/* HOME — long-form scrolling layout */}
      <div id="home" className="view" style={baseViewStyle(isActive("home"))}>
        <Hero />
        <SummaryHero />
        <StatsBar />
        <PillarCardStrip />
        <About />
        <AdvisoryCTA />
        <Geography />
        <BuilderTrust />
        <Testimonials />
        <Contact />
        <Footer />
      </div>

      {/* DEALROOM */}
      <div id="dealroom" className="view" style={innerViewStyle(isActive("dealroom"))}>
        <Dealroom />
        <Footer />
      </div>

      {/* ESTATES */}
      <div id="estates" className="view" style={innerViewStyle(isActive("estates"))}>
        <Estates />
        <Footer />
      </div>

      {/* CAPITAL OFFICE */}
      <div id="capital" className="view" style={innerViewStyle(isActive("capital"))}>
        <AdvisoryCTA />
        <IntelligenceFeed />
        <ListSellBuy />
        <Footer />
      </div>

      {/* ATELIER — Interiors + Build (coming soon) */}
      <div id="atelier" className="view" style={innerViewStyle(isActive("atelier"))}>
        <ComingSoon />
        <Footer />
      </div>
    </main>
  );
};

const Landing = () => {
  useEffect(() => {
    document.title = "House of Numbardar — Luxury Real Estate · Delhi NCR · Est. 1795";
  }, []);

  return (
    <ViewRouterProvider>
      <PageLoader />
      <CustomCursor />
      <Navigation />
      <ViewSwitch />
      <ContactModal />
      <WhatsAppButton />
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#2C0A0A",
            color: "#FAF6EF",
            border: "1px solid rgba(200,169,90,0.35)",
            borderRadius: 0,
            fontFamily: "Jost, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
    </ViewRouterProvider>
  );
};

const parseBriefSlug = () => {
  const hash = window.location.hash.replace(/^#\//, "");
  if (hash.startsWith("brief/")) return hash.slice("brief/".length);
  return null;
};

function App() {
  const [briefSlug, setBriefSlug] = useState(parseBriefSlug);

  useEffect(() => {
    const onHash = () => setBriefSlug(parseBriefSlug());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  if (briefSlug !== null) {
    return <ClientBrief slug={briefSlug} />;
  }

  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
